export default __webpack_public_path__ + "static/media/background-contact-form.ee945e4c.webp";